module.exports = __webpack_public_path__ + "img/PerrySpecial.a65ae3de.png";